import rimg from 'rimg-shopify'; // eslint-disable-line
import AsyncView from 'shopify-asyncview';

export default class StaticProductRecommendations {
  constructor(section) {
    this.section = section;
    this.productId = section.data.productId;
    this.limit = section.data.settings.limit;

    this.recommendationContainer = document.querySelector('[data-product-recommendations]');

    this.recommendUrl = `${window.Theme.routes.product_recommendations_url}?section_id=static-product-recommendations&limit=${this.limit}&product_id=${this.productId}`;

    this._loadRecomendations = this._loadRecomendations.bind(this);

    this._loadRecomendations();
  }

  _loadRecomendations() {
    AsyncView.load(
      this.recommendUrl,
    ).done(({ html }) => {
      this.recommendationContainer.innerHTML = html;

      rimg.watch(this.recommendationContainer);

      const productItems = this.recommendationContainer.querySelectorAll('.product-list-item');

      if (productItems.length) {
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }
    });
  }
}
